import { openBlock, createElementBlock, normalizeStyle, normalizeClass, createCommentVNode, createElementVNode, Fragment, renderList, toDisplayString, createTextVNode, pushScopeId, popScopeId, renderSlot, createVNode, Transition, withCtx, withDirectives, vShow, createBlock, resolveDynamicComponent, resolveComponent, inject, ref, watch, onBeforeMount, createStaticVNode, mergeProps, withModifiers, reactive, provide, toRefs } from 'vue';

const isValidColor = string => {
  if (typeof Option === 'undefined') {
    return true;
  }

  /* eslint-disable-next-line */
  const {
    style
  } = new Option();
  style.color = string;
  return style.color !== '';
};

var script$t = {
  name: 'Color',
  props: {
    className: {
      type: String,
      default: 'pon-color'
    },
    primary: {
      type: String,
      required: true,
      validator(value) {
        return isValidColor(value);
      }
    },
    secondary: {
      type: String,
      validator(value) {
        return isValidColor(value);
      }
    },
    selected: {
      type: Boolean,
      default: false
    },
    colorSelectSize: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

const _hoisted_1$o = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon-check",
  width: "14",
  height: "11",
  viewBox: "0 0 14 11"
};
const _hoisted_2$i = /*#__PURE__*/createElementVNode("path", {
  d: "M4.15266 8.92793L1.42763 6.16849C1.12136 5.85835 0.626612 5.85835 0.320341 6.16849C0.0140693 6.47863 0.0140693 6.97962 0.320341 7.28976L3.60294 10.6138C3.90921 10.924 4.40396 10.924 4.71023 10.6138L13.0188 2.2003C13.3251 1.89016 13.3251 1.38916 13.0188 1.07902C12.7126 0.768885 12.2178 0.768885 11.9115 1.07902L4.15266 8.92793Z",
  fill: "#004A99"
}, null, -1);
const _hoisted_3$e = [_hoisted_2$i];
const _hoisted_4$8 = {
  key: 3,
  class: "disabled-cross"
};
function render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    "data-testid": "pon-color",
    style: normalizeStyle({
      backgroundColor: $props.primary
    }),
    class: normalizeClass([{
      active: $props.selected,
      disabled: $props.disabled
    }, $props.className, $props.secondary && 'pon-color-multi', `pon-color-size--${$props.colorSelectSize}`])
  }, [$props.secondary ? (openBlock(), createElementBlock("span", {
    key: 0,
    "data-testid": "color-secondary",
    class: "pon-color-multi--secondary",
    style: normalizeStyle({
      backgroundColor: $props.secondary
    })
  }, null, 4)) : (openBlock(), createElementBlock("span", {
    key: 1,
    "data-testid": "color-primary",
    class: normalizeClass([$props.disabled && 'secondary-as-primary']),
    style: normalizeStyle({
      backgroundColor: $props.primary
    })
  }, null, 6)), $props.selected ? (openBlock(), createElementBlock("svg", _hoisted_1$o, _hoisted_3$e)) : createCommentVNode("", true), $props.disabled ? (openBlock(), createElementBlock("span", _hoisted_4$8)) : createCommentVNode("", true)], 6);
}

script$t.render = render$s;

var script$s = {
  name: 'Loader'
};

const _hoisted_1$n = {
  class: "pon-loader"
};
function render$r(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$n, [(openBlock(), createElementBlock(Fragment, null, renderList(12, index => {
    return createElementVNode("div", {
      key: index
    });
  }), 64))]);
}

script$s.render = render$r;
script$s.__scopeId = "data-v-e453d4f8";

var script$r = {
  name: 'MainTitle',
  props: {
    text: {
      type: String,
      default: '',
      required: true
    },
    titleClass: {
      type: String
    }
  }
};

function render$q(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("h1", {
    class: normalizeClass($props.titleClass)
  }, toDisplayString($props.text), 3);
}

script$r.render = render$q;

var script$q = {
  name: 'Button',
  props: {
    buttonClass: {
      type: String
    },
    text: {
      type: String,
      default: 'Button',
      required: true
    },
    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'white'].includes(value);
      }
    },
    size: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    url: {
      type: String
    },
    target: {
      type: String
    },
    icon: {
      type: Boolean
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
};

const _withScopeId$2 = n => (pushScopeId("data-v-0c0c2890"), n = n(), popScopeId(), n);
const _hoisted_1$m = ["href", "id", "target"];
const _hoisted_2$h = {
  key: 0,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 20 20",
  class: "pon-icon"
};
const _hoisted_3$d = /*#__PURE__*/_withScopeId$2(() => /*#__PURE__*/createElementVNode("path", {
  d: "M12.95 10.707l0.707-0.707-5.657-5.657-1.414 1.414 4.242 4.243-4.242 4.243 1.414 1.414 4.95-4.95z"
}, null, -1));
const _hoisted_4$7 = [_hoisted_3$d];
const _hoisted_5$6 = ["id", "disabled"];
const _hoisted_6$5 = {
  key: 0,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 20 20",
  class: "pon-icon"
};
const _hoisted_7$4 = /*#__PURE__*/_withScopeId$2(() => /*#__PURE__*/createElementVNode("path", {
  d: "M12.95 10.707l0.707-0.707-5.657-5.657-1.414 1.414 4.242 4.243-4.242 4.243 1.414 1.414 4.95-4.95z"
}, null, -1));
const _hoisted_8$3 = [_hoisted_7$4];
const _hoisted_9$3 = {
  key: 1,
  class: "pon-icon pon-icon--loading",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
const _hoisted_10$3 = /*#__PURE__*/_withScopeId$2(() => /*#__PURE__*/createElementVNode("circle", {
  style: {
    "opacity": "0.25"
  },
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1));
const _hoisted_11$3 = /*#__PURE__*/_withScopeId$2(() => /*#__PURE__*/createElementVNode("path", {
  style: {
    "opacity": "0.75"
  },
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1));
const _hoisted_12$2 = [_hoisted_10$3, _hoisted_11$3];
function render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.url ? (openBlock(), createElementBlock("a", {
    key: 0,
    href: $props.url,
    id: $props.id,
    class: normalizeClass([[`pon-btn--${$props.type}`, `pon-btn--${$props.size}`, {
      'has-icon': $props.icon
    }, $props.buttonClass], "pon-btn"]),
    target: $props.target,
    "data-testid": "pon-btn"
  }, [createTextVNode(toDisplayString($props.text) + " ", 1), $props.icon ? (openBlock(), createElementBlock("svg", _hoisted_2$h, _hoisted_4$7)) : createCommentVNode("", true)], 10, _hoisted_1$m)) : (openBlock(), createElementBlock("button", {
    key: 1,
    id: $props.id,
    disabled: $props.disabled,
    class: normalizeClass([[`pon-btn--${$props.type}`, `pon-btn--${$props.size}`, {
      'has-icon': $props.icon
    }, $props.buttonClass], "pon-btn"]),
    "data-testid": "pon-btn"
  }, [createTextVNode(toDisplayString($props.text) + " ", 1), $props.icon && !$props.isLoading ? (openBlock(), createElementBlock("svg", _hoisted_6$5, _hoisted_8$3)) : $props.icon && $props.isLoading ? (openBlock(), createElementBlock("svg", _hoisted_9$3, _hoisted_12$2)) : createCommentVNode("", true)], 10, _hoisted_5$6));
}

script$q.render = render$p;
script$q.__scopeId = "data-v-0c0c2890";

var script$p = {
  name: 'Price',
  props: {
    locale: {
      type: String,
      default: 'nl-NL'
    },
    currency: {
      type: String,
      default: 'EUR'
    },
    price: {
      type: Number,
      required: true
    }
  },
  methods: {
    format(price) {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency
        }).format(price);
      } catch (err) {
        /* eslint-disable-next-line */
        console.error(err);
        return '';
      }
    }
  },
  computed: {
    formattedPrice() {
      return this.format(this.price);
    }
  }
};

const _hoisted_1$l = {
  class: "pon-price",
  "data-testid": "price"
};
function render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", _hoisted_1$l, toDisplayString($options.formattedPrice), 1);
}

script$p.render = render$o;

var script$o = {
  name: 'StarRating',
  props: {
    lazyLoad: {
      type: Boolean,
      default: false
    },
    star_size: {
      type: Number,
      required: false,
      default: 12
    },
    active_star_color: {
      type: String,
      required: false,
      default: 'gold'
    },
    inactive_star_color: {
      type: String,
      required: false,
      default: '#f2f2f2'
    },
    total: {
      type: Number,
      required: false
    },
    total_suffix: {
      type: String,
      required: false
    },
    total_suffix_singular: {
      type: String,
      required: false
    },
    score: {
      type: Number,
      required: true
    },
    hasTrustpilot: {
      type: Boolean,
      default: false
    },
    trustpilotUrl: {
      type: String,
      required: false
    },
    trustpilotImgAlt: {
      type: String,
      required: false
    },
    trustpilotPoweredBy: {
      type: String,
      required: false
    },
    trustpilotImgUrl: {
      type: String,
      required: false
    },
    trustpilotImageSize: {
      type: String,
      default: 'small',
      validator(value) {
        return ['small', 'medium', 'large'].includes(value);
      }
    },
    scoreSize: {
      type: Number,
      default: 79
    },
    maxScoreSize: {
      type: Number,
      default: 52
    },
    wrapperClass: {
      type: String,
      required: false
    },
    starratingWrapperClass: {
      type: String,
      required: false
    },
    starratingStarsClass: {
      type: String,
      required: false
    },
    starratingStarClass: {
      type: String,
      required: false
    },
    scoreClass: {
      type: String,
      required: false
    },
    maxScoreClass: {
      type: String,
      required: false
    },
    starSpacing: {
      type: Number,
      default: 4
    }
  },
  methods: {
    starWidth(score, starPos) {
      const percentage = score + 1 - starPos;
      if (percentage <= 0) return 0;
      if (percentage > 0 && percentage < 1) return percentage * 100;
      if (percentage >= 1) return 100;
      return 0;
    }
  },
  computed: {
    barWidth() {
      return `${this.score * 20}%`;
    },
    reviewsCountText() {
      let suffix = this.total_suffix;
      if (this.total === 1 && this.total_suffix_singular) {
        suffix = this.total_suffix_singular;
      }
      return [this.total, suffix].join(' ');
    },
    wrapperClassValue() {
      return {
        [this.wrapperClass]: this.hasTrustpilot
      };
    }
  }
};

const _withScopeId$1 = n => (pushScopeId("data-v-508d3140"), n = n(), popScopeId(), n);
const _hoisted_1$k = {
  key: 0,
  class: "pon-star-rating__scores"
};
const _hoisted_2$g = /*#__PURE__*/_withScopeId$1(() => /*#__PURE__*/createElementVNode("svg", {
  width: "0",
  height: "0",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/createElementVNode("symbol", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "rating-star"
}, [/*#__PURE__*/createElementVNode("path", {
  d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417\n            5.388 2.833-8.718-7.416-5.389h9.167z"
})])], -1));
const _hoisted_3$c = ["width", "height"];
const _hoisted_4$6 = ["fill"];
const _hoisted_5$5 = ["width", "height"];
const _hoisted_6$4 = ["fill"];
const _hoisted_7$3 = {
  key: 0,
  class: "pon-star-rating__count"
};
const _hoisted_8$2 = {
  key: 1,
  class: "pon-star-rating__trustpilot-wrapper"
};
const _hoisted_9$2 = ["href"];
const _hoisted_10$2 = {
  class: "pon-star-rating__trustpilot-poweredby"
};
const _hoisted_11$2 = ["loading", "src", "data-src", "alt"];
const _hoisted_12$1 = {
  class: "pon-star-rating__trustpilot-reviews"
};
function render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["pon-star-rating", $options.wrapperClassValue])
  }, [$props.score && $props.hasTrustpilot ? (openBlock(), createElementBlock("div", _hoisted_1$k, [createElementVNode("span", {
    style: normalizeStyle({
      fontSize: $props.scoreSize + 'px'
    }),
    class: normalizeClass([$props.scoreClass, "pon-star-rating__scores-score"])
  }, [createTextVNode(toDisplayString($props.score) + " ", 1), createElementVNode("sup", {
    style: normalizeStyle({
      fontSize: $props.maxScoreSize + 'px'
    }),
    class: normalizeClass([$props.maxScoreClass, "pon-star-rating__scores-score--max"])
  }, "/ 5 ", 6)], 6)])) : createCommentVNode("", true), _hoisted_2$g, createElementVNode("div", {
    class: normalizeClass(["pon-star-rating__wrapper", $props.starratingWrapperClass])
  }, [createElementVNode("div", {
    class: normalizeClass(["pon-star-rating__stars", $props.starratingStarsClass])
  }, [(openBlock(), createElementBlock(Fragment, null, renderList(5, index => {
    return createElementVNode("div", {
      key: index,
      style: normalizeStyle([{
        position: 'relative'
      }, index != 5 && {
        marginRight: `${$props.starSpacing}px`
      }])
    }, [(openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: normalizeClass(["pon-star-rating__star", $props.starratingStarClass]),
      width: $props.star_size,
      height: $props.star_size
    }, [createElementVNode("use", {
      href: "#rating-star",
      fill: $props.inactive_star_color
    }, null, 8, _hoisted_4$6)], 10, _hoisted_3$c)), createElementVNode("div", {
      class: "pon-star-rating__overlay",
      style: normalizeStyle({
        width: `${$options.starWidth($props.score, index)}%`
      })
    }, [(openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "pon-star-rating__star",
      width: $props.star_size,
      height: $props.star_size
    }, [createElementVNode("use", {
      href: "#rating-star",
      fill: $props.active_star_color
    }, null, 8, _hoisted_6$4)], 8, _hoisted_5$5))], 4)], 4);
  }), 64))], 2), $options.reviewsCountText && !$props.hasTrustpilot ? (openBlock(), createElementBlock("div", _hoisted_7$3, toDisplayString($options.reviewsCountText), 1)) : createCommentVNode("", true)], 2), $props.hasTrustpilot ? (openBlock(), createElementBlock("div", _hoisted_8$2, [createElementVNode("a", {
    href: $props.trustpilotUrl,
    class: "pon-star-rating__truspilot-link"
  }, [createElementVNode("span", _hoisted_10$2, toDisplayString($props.trustpilotPoweredBy), 1), createElementVNode("img", {
    loading: $props.lazyLoad && 'lazy',
    src: !$props.lazyLoad && $props.trustpilotImgUrl,
    "data-src": $props.trustpilotImgUrl,
    alt: $props.trustpilotImgAlt,
    class: normalizeClass(`pon-star-rating__trustpilot-logo--${$props.trustpilotImageSize}`)
  }, null, 10, _hoisted_11$2)], 8, _hoisted_9$2), createElementVNode("span", _hoisted_12$1, " • " + toDisplayString($options.reviewsCountText), 1)])) : createCommentVNode("", true)], 2);
}

script$o.render = render$n;
script$o.__scopeId = "data-v-508d3140";

var script$n = {
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      required: true,
      validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    bar_color: {
      type: String,
      default: 'blue',
      validator(value) {
        return isValidColor(value);
      }
    },
    start_color: {
      type: String,
      validator(value) {
        return isValidColor(value);
      }
    },
    end_color: {
      type: String,
      validator(value) {
        return isValidColor(value);
      }
    }
  },
  methods: {
    createBackgroundString() {
      return `linear-gradient(to right, ${this.start_color}, ${this.end_color})`;
    }
  }
};

const _hoisted_1$j = {
  class: "pon-progress-bar"
};
const _hoisted_2$f = {
  class: "pon-progress-bar__bg"
};
function render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$j, [createElementVNode("div", _hoisted_2$f, [createElementVNode("div", {
    style: normalizeStyle({
      width: `${$props.percentage}%`,
      backgroundColor: $props.bar_color,
      backgroundImage: $props.start_color && $props.end_color && $options.createBackgroundString()
    }),
    class: "pon-progress-bar__fill",
    "data-testid": "progress-bar-fill"
  }, null, 4)])]);
}

script$n.render = render$m;

var script$m = {
  name: 'Swatches',
  props: {
    colors: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(element => element.hasOwnProperty('tag_identifier') && element.hasOwnProperty('primary_label') && element.hasOwnProperty('primary_rgb'));
      }
    },
    swatchClass: {
      type: String
    },
    activeSwatch: {
      type: Object,
      default: () => ({})
    },
    swatchSize: {
      type: String,
      default: 'medium'
    }
  },
  methods: {
    isActiveSwatch(tagIdentifier) {
      if (this.activeSwatch) {
        return this.activeSwatch.tag_identifier === tagIdentifier;
      }
      return false;
    },
    setActiveSwatch(swatch) {
      this.$emit('update:swatch', swatch);
    },
    prefixRgb(value) {
      return `rgb(${value})`;
    }
  }
};

const _hoisted_1$i = {
  class: "pon-swatch-wrapper",
  "data-testid": "pon-swatches"
};
const _hoisted_2$e = ["onClick"];
function render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$i, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.colors, (color, index) => {
    return openBlock(), createElementBlock("button", {
      key: index,
      style: normalizeStyle({
        backgroundColor: $options.prefixRgb(color.primary_rgb)
      }),
      onClick: $event => _ctx.$emit('update:swatch', color),
      class: normalizeClass(["pon-swatch", [{
        active: $options.isActiveSwatch(color.tag_identifier)
      }, $props.swatchClass, `pon-swatch--${$props.swatchSize}`, color.secondary_rgb && 'pon-swatch-multi']])
    }, [color.secondary_rgb ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass([`pon-swatch-multi--secondary pon-swatch-multi--secondary-${$props.swatchSize}`]),
      style: normalizeStyle({
        backgroundColor: $options.prefixRgb(color.secondary_rgb)
      })
    }, null, 6)) : createCommentVNode("", true)], 14, _hoisted_2$e);
  }), 128))]);
}

script$m.render = render$l;
script$m.__scopeId = "data-v-100ffa3a";

var script$l = {
  name: 'Accordion',
  props: {
    hasIcon: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: String,
      default: 'pon-accordion'
    },
    bodyClass: {
      type: String,
      default: ''
    },
    headerClass: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.isOpen && this.toggle();
  },
  data() {
    return {
      showContent: false
    };
  },
  methods: {
    toggle() {
      this.showContent = !this.showContent;
    },
    beforeEnter(el) {
      const element = el;
      element.style.height = '0';
    },
    enter(el) {
      const element = el;
      element.style.height = `${element.scrollHeight}px`;
    },
    beforeLeave(el) {
      const element = el;
      element.style.height = `${element.scrollHeight}px`;
    },
    leave(el) {
      const element = el;
      element.style.height = '0';
    }
  }
};

const _hoisted_1$h = {
  key: 0,
  id: "pon-accordion-toggle",
  class: "pon-accordion__toggle pon-accordion__header-wrapper"
};
const _hoisted_2$d = {
  key: 1,
  id: "pon-accordion-toggle",
  class: "accordion__toggle pon-accordion__header-wrapper"
};
function render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(['pon-accordion', $props.wrapperClass]),
    "data-testid": "pon-accordion"
  }, [createElementVNode("div", {
    class: normalizeClass([!$data.showContent ? 'hover' : '', $data.showContent ? 'pon-accordion__header-open' : 'pon-accordion__header-closed', 'pon-accordion__header', $props.headerClass]),
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.toggle && $options.toggle(...arguments);
    })
  }, [$props.hasIcon ? (openBlock(), createElementBlock("div", _hoisted_1$h, [createElementVNode("div", {
    id: "pon-accordion-plus-minus-toggle",
    class: normalizeClass(['plus-minus-toggle', {
      collapsed: !$data.showContent
    }])
  }, null, 2), renderSlot(_ctx.$slots, "header")])) : (openBlock(), createElementBlock("div", _hoisted_2$d, [renderSlot(_ctx.$slots, "header")])), createVNode(Transition, {
    name: "accordion",
    onBeforeEnter: $options.beforeEnter,
    onEnter: $options.enter,
    onBeforeLeave: $options.beforeLeave,
    onLeave: $options.leave,
    ref: "accordion"
  }, {
    default: withCtx(() => [withDirectives(createElementVNode("div", {
      class: normalizeClass(['pon-accordion__body', $props.bodyClass])
    }, [renderSlot(_ctx.$slots, "accordionContent")], 2), [[vShow, $data.showContent]])]),
    _: 3
  }, 8, ["onBeforeEnter", "onEnter", "onBeforeLeave", "onLeave"])], 2)], 2);
}

script$l.render = render$k;

var script$k = {
  name: 'Slogan',
  props: {
    htmlTag: {
      type: String,
      default: 'h2'
    },
    sloganClass: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
};

function render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($props.htmlTag), {
    class: normalizeClass($props.sloganClass)
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString($props.text), 1)]),
    _: 1
  }, 8, ["class"]);
}

script$k.render = render$j;

var script$j = {
  name: 'USP',
  props: {
    lazyLoad: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    descriptionClass: {
      type: String,
      default: ''
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: 'alt'
    }
  }
};

const _hoisted_1$g = ["loading", "src", "data-src", "alt"];
function render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([$props.wrapperClass, "pon-usp-wrapper"])
  }, [createElementVNode("img", {
    class: normalizeClass(["pon-usp-image", $props.imageClass]),
    loading: $props.lazyLoad && 'lazy',
    src: !$props.lazyLoad && $props.imageUrl,
    "data-src": $props.imageUrl,
    alt: $props.imageAlt,
    "data-testid": "pon-usp__image"
  }, null, 10, _hoisted_1$g), createElementVNode("p", {
    class: normalizeClass([$props.descriptionClass, "pon-usp-description"])
  }, toDisplayString($props.description), 3)], 2);
}

script$j.render = render$i;
script$j.__scopeId = "data-v-064428f0";

var script$i = {
  name: 'Breadcrumb',
  props: {
    label: {
      type: String,
      required: true
    },
    link: {
      type: String
    }
  }
};

const _hoisted_1$f = ["href"];
const _hoisted_2$c = {
  key: 1
};
function render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", null, [$props.link ? (openBlock(), createElementBlock("a", {
    key: 0,
    href: $props.link
  }, toDisplayString($props.label), 9, _hoisted_1$f)) : (openBlock(), createElementBlock("span", _hoisted_2$c, toDisplayString($props.label), 1))]);
}

script$i.render = render$h;

var script$h = {
  name: 'Breadcrumbs',
  components: {
    Breadcrumb: script$i
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    separator: {
      type: String,
      default: '/'
    }
  },
  computed: {
    cssProps() {
      return {
        '--breadcrumb-separator': `'${this.separator}'`
      };
    }
  }
};

function render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Breadcrumb = resolveComponent("Breadcrumb");
  return openBlock(), createElementBlock("ul", {
    style: normalizeStyle($options.cssProps),
    class: "pon-breadcrumbs",
    "data-testid": "breadcrumbs"
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.items, (item, index) => {
    return openBlock(), createBlock(_component_Breadcrumb, {
      key: index,
      label: item.label,
      link: item.link,
      "data-testid": "breadcrumb-item"
    }, null, 8, ["label", "link"]);
  }), 128))], 4);
}

script$h.render = render$g;

var script$g = {
  name: 'Tab',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const tabsData = inject('tabsData');
    const isActive = ref(props.title === tabsData.currentTab);
    const add = inject('addTab');
    watch(() => tabsData.currentTab, () => {
      isActive.value = props.title === tabsData.currentTab;
    });
    onBeforeMount(() => {
      add({
        title: props.title,
        isActive
      });
    });
    return {
      isActive
    };
  }
};

const _hoisted_1$e = {
  key: 0,
  class: "pon-tab",
  role: "tabpanel",
  "data-testid": "tab-content"
};
function render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return $setup.isActive ? (openBlock(), createElementBlock("div", _hoisted_1$e, [renderSlot(_ctx.$slots, "default")])) : createCommentVNode("", true);
}

script$g.render = render$f;

var script$f = {
  name: 'Tooltip',
  props: {
    hasHover: {
      type: Boolean
    },
    tooltipClass: {
      type: String
    },
    tooltipSize: {
      type: Number,
      default: 16
    }
  },
  data() {
    return {
      tooltipHover: false,
      hoverTimeOut: null
    };
  },
  methods: {
    showTooltip() {
      clearTimeout(this.hoverTimeOut);
      if (this.hasHover) {
        this.tooltipHover = this.hasHover;
      }
    },
    hideTooltip() {
      if (!this.hasHover) return;
      this.hoverTimeOut = setTimeout(() => this.tooltipHover = !this.hasHover, 200);
    }
  }
};

const _withScopeId = n => (pushScopeId("data-v-11b51276"), n = n(), popScopeId(), n);
const _hoisted_1$d = ["width", "height"];
const _hoisted_2$b = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("g", {
  transform: "translate(.5 .5)",
  "data-name": "Icon/Info Copy 6"
}, [/*#__PURE__*/createElementVNode("circle", {
  "data-name": "Oval 2",
  cx: "6",
  cy: "6",
  r: "6",
  style: {
    "fill": "none",
    "stroke": "#7f7f7f",
    "stroke-linejoin": "round",
    "stroke-miterlimit": "10"
  }
}), /*#__PURE__*/createElementVNode("path", {
  d: "M1.43\n          7.056H.123V3H1.43v4.055zm-.659-5.5A.777.777 0 0 1 .771 0a.768.768 0 0 1 .782.771.783.783 0 0 1-.782.782z",
  transform: "translate(5.143 2.571)",
  style: {
    "fill": "#7f7f7f"
  }
})], -1));
const _hoisted_3$b = [_hoisted_2$b];
function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["pon-tooltip", [{
      'pon-tooltip-hover': !$props.hasHover
    }, $props.tooltipClass]]),
    "data-testid": "tooltip",
    onMouseover: _cache[0] || (_cache[0] = $event => $options.showTooltip()),
    onMouseleave: _cache[1] || (_cache[1] = $event => $options.hideTooltip())
  }, [(openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.tooltipSize,
    height: $props.tooltipSize,
    viewBox: "0 0 13 13"
  }, _hoisted_3$b, 8, _hoisted_1$d)), $data.tooltipHover ? renderSlot(_ctx.$slots, "default", {
    key: 0
  }) : createCommentVNode("", true)], 34);
}

script$f.render = render$e;
script$f.__scopeId = "data-v-11b51276";

var script$e = {
  name: 'BikeFrameIconLow'
};

const _hoisted_1$c = {
  class: "pon-icon__bike-frame-low",
  width: "34px",
  height: "20px",
  viewBox: "0 0 34 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2$a = /*#__PURE__*/createStaticVNode("<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-149.000000, -600.000000)\" fill-rule=\"nonzero\"><g transform=\"translate(149.000000, 599.000000)\"><g fill=\"#BBBBBB\"><path d=\"M27,20.5 C23.4101491,20.5 20.5,17.5898509 20.5,14 C20.5,10.4101491 23.4101491,7.5 27,\n            7.5 C30.5898509,7.5 33.5,10.4101491 33.5,14 C33.5,17.5898509 30.5898509,20.5 27,20.5 Z M27,\n            19.5 C30.0375661,19.5 32.5,17.0375661 32.5,14 C32.5,10.9624339 30.0375661,8.5 27,8.5 C23.9624339,\n            8.5 21.5,10.9624339 21.5,14 C21.5,17.0375661 23.9624339,19.5 27,19.5 Z\" transform=\"translate(27.000000, 14.000000) scale(-1, 1) translate(-27.000000, -14.000000) \"></path><path d=\"M7,20.5 C3.41014913,20.5 0.5,17.5898509 0.5,14 C0.5,10.4101491 3.41014913,7.5 7,7.5 C10.5898509,\n            7.5 13.5,10.4101491 13.5,14 C13.5,17.5898509 10.5898509,20.5 7,20.5 Z M7,19.5 C10.0375661,19.5 12.5,\n            17.0375661 12.5,14 C12.5,10.9624339 10.0375661,8.5 7,8.5 C3.96243388,8.5 1.5,10.9624339 1.5,14 C1.5,\n            17.0375661 3.96243388,19.5 7,19.5 Z\" id=\"Oval-2-Copy\" transform=\"translate(7.000000, 14.000000) scale(-1, 1) translate(-7.000000, -14.000000) \"></path><path d=\"M29.2096991,8.70458575 C29.28117,8.4378527 29.5553385,8.27956145 29.8220716,8.35103236 C30.0888046,\n            8.42250326 30.2470959,8.69667174 30.175625,8.96340479 L29.345022,12.0632573 C29.2492963,\n            12.4205105 28.8122631,12.5537781 28.533482,12.3107258 L18.1186018,3.23062455 C17.9104577,\n            3.04915643 17.8888326,2.73331339 18.0703008,2.52516937 C18.2517689,2.31702535 18.5676119,\n            2.29540027 18.775756,2.47686839 L28.5865297,11.0302859 L29.2096991,8.70458575 Z\" transform=\"translate(24.069979, 7.393955) scale(-1, 1) rotate(-105.000000)\n                  translate(-24.069979, -7.393955) \"></path><path d=\"M16.2666465,6.65161165 C16.0905391,6.43891279 16.1202024,6.12372307 16.3329012,\n            5.94761569 C16.5456001,5.77150831 16.8607898,5.80117157 17.0368972,6.01387042 L23.3851253,\n            13.6811294 C23.655002,14.0070808 23.4231758,14.5 23,14.5 L13.866171,14.5 C13.7203221,\n            14.5 13.5817435,14.4363174 13.4867544,14.3256425 L6.62058335,6.32564245 C6.44073599,\n            6.11609642 6.46481152,5.80043071 6.67435755,5.62058335 C6.88390358,5.44073599 7.19956929,\n            5.46481152 7.37941665,5.67435755 L14.0959416,13.5 L21.9368778,13.5 L16.2666465,6.65161165 Z\" transform=\"translate(15.000472, 9.999996) scale(-1, 1) translate(-15.000472, -9.999996) \"></path><path d=\"M13.5699794,4.5 L10.4761404,14.1526117 C10.3918553,14.4155768 10.1103533,14.5604255 9.84738828,\n            14.4761404 C9.58442321,14.3918553 9.43957449,14.1103533 9.52385962,13.8473883 L12.729043,\n            3.84738828 C12.7953826,3.64041208 12.9878355,3.5 13.2051834,3.5 L16,3.5 C16.2761424,3.5 16.5,\n            3.72385763 16.5,4 C16.5,4.27614237 16.2761424,4.5 16,4.5 L13.5699794,4.5 Z\" transform=\"translate(12.999933, 9.000067) scale(-1, 1) translate(-12.999933, -9.000067) \"></path></g><path d=\"M22.52276,5.8508625 C22.6051264,5.58729014 22.8855651,5.44039365 23.1491375,5.52276001 C23.4127099,\n          5.60512638 23.5596064,5.88556513 23.47724,6.1491375 L20.97724,14.1491375 C20.9120095,14.3578751 20.7186925,\n          14.5 20.5,14.5 L20.366171,14.5 C20.2203221,14.5 20.0817435,14.4363174 19.9867544,14.3256425 L13.1205833,\n          6.32564245 C12.940736,6.11609642 12.9648115,5.80043071 13.1743575,5.62058335 C13.3839036,\n          5.44073599 13.6995693,5.46481152 13.8794167,5.67435755 L20.2561309,13.1040755 L22.52276,5.8508625 Z\" fill=\"#000000\" transform=\"translate(18.250062, 9.999933) scale(-1, 1) translate(-18.250062, -9.999933) \"></path></g></g></g>", 1);
const _hoisted_3$a = [_hoisted_2$a];
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$c, _hoisted_3$a);
}

script$e.render = render$d;

var script$d = {
  name: 'BikeFrameIconMid'
};

const _hoisted_1$b = {
  class: "pon-icon__bike-frame-mid",
  width: "34px",
  height: "20px",
  viewBox: "0 0 34 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2$9 = /*#__PURE__*/createStaticVNode("<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-299.000000, -600.000000)\" fill-rule=\"nonzero\"><g transform=\"translate(299.000000, 599.000000)\"><g fill=\"#BBBBBB\"><path d=\"M27,20.5 C23.4101491,20.5 20.5,17.5898509 20.5,14 C20.5,10.4101491 23.4101491,7.5 27,\n            7.5 C30.5898509,7.5 33.5,10.4101491 33.5,14 C33.5,17.5898509 30.5898509,20.5 27,20.5 Z M27,\n            19.5 C30.0375661,19.5 32.5,17.0375661 32.5,14 C32.5,10.9624339 30.0375661,8.5 27,8.5 C23.9624339,\n            8.5 21.5,10.9624339 21.5,14 C21.5,17.0375661 23.9624339,19.5 27,19.5 Z\" transform=\"translate(27.000000, 14.000000) scale(-1, 1) translate(-27.000000, -14.000000) \"></path><path d=\"M7,20.5 C3.41014913,20.5 0.5,17.5898509 0.5,14 C0.5,10.4101491 3.41014913,7.5 7,7.5 C10.5898509,\n            7.5 13.5,10.4101491 13.5,14 C13.5,17.5898509 10.5898509,20.5 7,20.5 Z M7,19.5 C10.0375661,19.5 12.5,\n            17.0375661 12.5,14 C12.5,10.9624339 10.0375661,8.5 7,8.5 C3.96243388,8.5 1.5,10.9624339 1.5,14 C1.5,\n            17.0375661 3.96243388,19.5 7,19.5 Z\" transform=\"translate(7.000000, 14.000000) scale(-1, 1) translate(-7.000000, -14.000000) \"></path><path d=\"M29.2096991,8.70458575 C29.28117,8.4378527 29.5553385,8.27956145 29.8220716,\n            8.35103236 C30.0888046,8.42250326 30.2470959,8.69667174 30.175625,8.96340479 L29.345022,\n            12.0632573 C29.2492963,12.4205105 28.8122631,12.5537781 28.533482,12.3107258 L18.1186018,\n            3.23062455 C17.9104577,3.04915643 17.8888326,2.73331339 18.0703008,2.52516937 C18.2517689,\n            2.31702535 18.5676119,2.29540027 18.775756,2.47686839 L28.5865297,11.0302859 L29.2096991,\n            8.70458575 Z\" transform=\"translate(24.069979, 7.393955) scale(-1, 1) rotate(-105.000000)\n                  translate(-24.069979, -7.393955) \"></path><path d=\"M16.2802002,6.66798154 C16.1040928,6.45528268 16.1337561,6.14009296 16.346455,\n            5.96398558 C16.5591538,5.7878782 16.8743435,5.81754146 17.0504509,6.03024031 L23.3851253,\n            13.6811294 C23.655002,14.0070808 23.4231758,14.5 23,14.5 L13.866171,14.5 C13.7203221,\n            14.5 13.5817435,14.4363174 13.4867544,14.3256425 L6.62058335,6.32564245 C6.26519162,5.91156394 6.73553771,\n            5.30875186 7.2236068,5.5527864 L15.2236068,9.5527864 C15.470596,9.67628103 15.5707082,\n            9.97661755 15.4472136,10.2236068 C15.323719,10.470596 15.0233825,10.5707082 14.7763932,\n            10.4472136 L8.99468508,7.55635954 L14.0959416,13.5 L21.9368778,13.5 L16.2802002,6.66798154 Z\" transform=\"translate(14.998567, 9.998223) scale(-1, 1) translate(-14.998567, -9.998223) \"></path><path d=\"M13.5699794,4.5 L10.4761404,14.1526117 C10.3918553,14.4155768 10.1103533,14.5604255 9.84738828,\n            14.4761404 C9.58442321,14.3918553 9.43957449,14.1103533 9.52385962,13.8473883 L12.729043,\n            3.84738828 C12.7953826,3.64041208 12.9878355,3.5 13.2051834,3.5 L16,3.5 C16.2761424,3.5 16.5,\n            3.72385763 16.5,4 C16.5,4.27614237 16.2761424,4.5 16,4.5 L13.5699794,4.5 Z\" transform=\"translate(12.999933, 9.000067) scale(-1, 1) translate(-12.999933, -9.000067) \"></path></g><path d=\"M23.2214438,9.65171141 C23.4453576,9.76231943 23.5533173,10.021187 23.4743416,10.2581139 L22.1743416,\n          14.1581139 C22.1062846,14.362285 21.9152152,14.5 21.7,14.5 L21.566171,14.5 C21.4203221,14.5 21.2817435,\n          14.4363174 21.1867544,14.3256425 L14.3205833,6.32564245 C13.9660665,5.91258324 14.4334058,\n          5.31063241 14.9214438,5.55171141 L23.2214438,9.65171141 Z M16.6747841,7.53317222 L21.4672693,\n          13.1170532 L22.3878563,10.3552922 L16.6747841,7.53317222 Z M21.6036076,13.9678692 L21.7,\n          13.8851384 L21.7,13.5 L21.566171,13.5 L21.566171,13.9553903 L21.6036076,13.9678692 Z\" fill=\"#000000\" transform=\"translate(18.848153, 9.998253) scale(-1, 1) translate(-18.848153, -9.998253) \"></path></g></g></g>", 1);
const _hoisted_3$9 = [_hoisted_2$9];
function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$b, _hoisted_3$9);
}

script$d.render = render$c;

var script$c = {
  name: 'BikeFrameIconHigh'
};

const _hoisted_1$a = {
  class: "pon-icon__bike-frame-high",
  width: "34px",
  height: "20px",
  viewBox: "0 0 34 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2$8 = /*#__PURE__*/createStaticVNode("<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-449.000000, -600.000000)\" fill-rule=\"nonzero\"><g transform=\"translate(449.000000, 599.000000)\"><g fill=\"#BBBBBB\"><path d=\"M27,20.5 C23.4101491,20.5 20.5,17.5898509 20.5,14 C20.5,10.4101491 23.4101491,7.5 27,\n          7.5 C30.5898509,7.5 33.5,10.4101491 33.5,14 C33.5,17.5898509 30.5898509,20.5 27,20.5 Z M27,19.5 C30.0375661,\n          19.5 32.5,17.0375661 32.5,14 C32.5,10.9624339 30.0375661,8.5 27,8.5 C23.9624339,8.5 21.5,10.9624339 21.5,\n          14 C21.5,17.0375661 23.9624339,19.5 27,19.5 Z\" transform=\"translate(27.000000, 14.000000) scale(-1, 1) translate(-27.000000, -14.000000) \"></path><path d=\"M7,20.5 C3.41014913,20.5 0.5,17.5898509 0.5,14 C0.5,10.4101491 3.41014913,7.5 7,7.5 C10.5898509,\n          7.5 13.5,10.4101491 13.5,14 C13.5,17.5898509 10.5898509,20.5 7,20.5 Z M7,19.5 C10.0375661,19.5 12.5,\n          17.0375661 12.5,14 C12.5,10.9624339 10.0375661,8.5 7,8.5 C3.96243388,8.5 1.5,10.9624339 1.5,14 C1.5,\n          17.0375661 3.96243388,19.5 7,19.5 Z\" transform=\"translate(7.000000, 14.000000) scale(-1, 1) translate(-7.000000, -14.000000) \"></path><path d=\"M29.2096991,8.70458575 C29.28117,8.4378527 29.5553385,8.27956145 29.8220716,8.35103236 C30.0888046,\n          8.42250326 30.2470959,8.69667174 30.175625,8.96340479 L29.345022,12.0632573 C29.2492963,12.4205105 28.8122631,\n          12.5537781 28.533482,12.3107258 L18.1186018,3.23062455 C17.9104577,3.04915643 17.8888326,\n          2.73331339 18.0703008,2.52516937 C18.2517689,2.31702535 18.5676119,2.29540027 18.775756,\n          2.47686839 L28.5865297,11.0302859 L29.2096991,8.70458575 Z\" transform=\"translate(24.069979, 7.393955) scale(-1, 1) rotate(-105.000000)\n                translate(-24.069979, -7.393955) \"></path><path d=\"M6.62058335,6.32564245 C6.34227011,6.00137061 6.57267052,5.5 7,5.5 L16.3762737,5.5 C16.5252193,\n          5.5 16.6664103,5.56640394 16.761399,5.68112939 L23.3851253,13.6811294 C23.655002,14.0070808 23.4231758,\n          14.5 23,14.5 L13.866171,14.5 C13.7203221,14.5 13.5817435,14.4363174 13.4867544,14.3256425 L6.62058335,\n          6.32564245 Z M8.08804193,6.5 L14.0959416,13.5 L21.9368778,13.5 L16.1411173,6.5 L8.08804193,6.5 Z\" transform=\"translate(14.999993, 10.000000) scale(-1, 1) translate(-14.999993, -10.000000) \"></path><path d=\"M13.5699794,4.5 L10.4761404,14.1526117 C10.3918553,14.4155768 10.1103533,14.5604255 9.84738828,\n          14.4761404 C9.58442321,14.3918553 9.43957449,14.1103533 9.52385962,13.8473883 L12.729043,\n          3.84738828 C12.7953826,3.64041208 12.9878355,3.5 13.2051834,3.5 L16,3.5 C16.2761424,3.5 16.5,3.72385763 16.5,\n          4 C16.5,4.27614237 16.2761424,4.5 16,4.5 L13.5699794,4.5 Z\" transform=\"translate(12.999933, 9.000067) scale(-1, 1) translate(-12.999933, -9.000067) \"></path></g><path d=\"M13.1205833,6.32564245 C12.8422701,6.00137061 13.0726705,5.5 13.5,5.5 L23,5.5 C23.3373201,\n        5.5 23.5778541,5.8271722 23.47724,6.1491375 L20.97724,14.1491375 C20.9120095,14.3578751 20.7186925,\n        14.5 20.5,14.5 L20.366171,14.5 C20.2203221,14.5 20.0817435,14.4363174 19.9867544,14.3256425 L13.1205833,\n        6.32564245 Z M14.5880419,6.5 L20.2561309,13.1040755 L22.3199045,6.5 L14.5880419,6.5 Z M20.4018924,\n        13.9693414 L20.5,13.8851384 L20.5,13.5 L20.366171,13.5 L20.366171,13.9581784 L20.4018924,13.9693414 Z\" fill=\"#000000\" transform=\"translate(18.249691, 10.000000) scale(-1, 1) translate(-18.249691, -10.000000) \"></path></g></g></g>", 1);
const _hoisted_3$8 = [_hoisted_2$8];
function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$a, _hoisted_3$8);
}

script$c.render = render$b;

var script$b = {
  name: 'BikeFrame',
  components: {
    BikeFrameIconLow: script$e,
    BikeFrameIconMid: script$d,
    BikeFrameIconHigh: script$c
  },
  props: {
    frame: {
      type: String,
      required: true,
      validator(value) {
        return ['low', 'frame-low', 'mid', 'frame-mid', 'high', 'frame-high'].includes(value);
      }
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BikeFrameIconLow = resolveComponent("BikeFrameIconLow");
  const _component_BikeFrameIconMid = resolveComponent("BikeFrameIconMid");
  const _component_BikeFrameIconHigh = resolveComponent("BikeFrameIconHigh");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([{
      active: $props.selected
    }, {
      disabled: $props.disabled
    }, 'pon-frame']),
    "data-testid": "pon-frame"
  }, [$props.frame === 'low' || $props.frame === 'frame-low' ? (openBlock(), createBlock(_component_BikeFrameIconLow, {
    key: 0
  })) : createCommentVNode("", true), $props.frame === 'mid' || $props.frame === 'frame-mid' ? (openBlock(), createBlock(_component_BikeFrameIconMid, {
    key: 1
  })) : createCommentVNode("", true), $props.frame === 'high' || $props.frame === 'frame-high' ? (openBlock(), createBlock(_component_BikeFrameIconHigh, {
    key: 2
  })) : createCommentVNode("", true)], 2);
}

script$b.render = render$a;

var script$a = {
  name: 'ExpandableImage',
  inheritAttrs: false,
  props: {
    alt: {
      type: String,
      default: ''
    },
    animationDuration: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      expanded: false,
      expandedOverride: false,
      clientRect: null,
      isZooming: false
    };
  },
  computed: {
    expandedImageClass() {
      return {
        expanded: this.expanded || this.expandedOverride,
        isZooming: this.isZooming
      };
    },
    animationDurationtoMs() {
      return this.animationDuration / 1000;
    },
    transitionStyles() {
      return `transition: all ${this.animationDurationtoMs}s ease-in-out;`;
    }
  },
  methods: {
    closeImage() {
      this.expandedOverride = true;
      this.isZooming = true;
      const pos = this.getElementPosition(this.$refs.expandableImage);
      this.$refs.expandedImage.style.width = this.toPx(pos.width);
      this.$refs.expandedImage.style.height = this.toPx(pos.height);
      this.$refs.expandedImage.style.top = this.toPx(pos.top);
      this.$refs.expandedImage.style.left = this.toPx(pos.left);
      setTimeout(() => {
        this.expandedOverride = false;
        this.isZooming = false;
        this.$refs.expandedImage.style.width = null;
        this.$refs.expandedImage.style.height = null;
        this.$refs.expandedImage.style.top = null;
        this.$refs.expandedImage.style.left = null;
      }, this.animationDuration);
      this.expanded = false;
      document.body.style.overflow = 'auto';
    },
    openImage() {
      const pos = this.getElementPosition(this.$refs.expandableImage);
      this.$refs.expandedImage.style.width = this.toPx(pos.width);
      this.$refs.expandedImage.style.height = this.toPx(pos.height);
      this.$refs.expandedImage.style.top = this.toPx(pos.top);
      this.$refs.expandedImage.style.left = this.toPx(pos.left);
      this.expanded = true;
      this.isZooming = true;
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        this.$refs.closeButton.classList.toggle('is-shown');
      }, 200);
      setTimeout(() => {
        this.isZooming = false;
      }, this.animationDuration);
    },
    toPx(val) {
      return [val, 'px'].join('');
    },
    getElementPosition(elem) {
      const rect = elem.getBoundingClientRect();
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
      };
    }
  },
  watch: {
    expanded(expanded) {
      this.$nextTick(() => {
        if (expanded) {
          setTimeout(() => {
            this.$refs.expandedImage.style.width = null;
            this.$refs.expandedImage.style.height = null;
            this.$refs.expandedImage.style.top = null;
            this.$refs.expandedImage.style.left = null;
          }, 1);
        }
      });
    }
  }
};

const _hoisted_1$9 = ["alt"];
const _hoisted_2$7 = /*#__PURE__*/createElementVNode("span", {
  class: "pon-expandable-image-close-icon"
}, null, -1);
const _hoisted_3$7 = [_hoisted_2$7];
const _hoisted_4$5 = ["alt"];
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [createElementVNode("div", {
    class: "pon-expandable-image",
    ref: "expandableImage",
    style: normalizeStyle($options.transitionStyles)
  }, [createElementVNode("img", mergeProps(_ctx.$attrs, {
    alt: $props.alt,
    style: {
      "width": "100%"
    },
    onClick: _cache[0] || (_cache[0] = withModifiers($event => $options.openImage(), ["self"]))
  }), null, 16, _hoisted_1$9)], 4), withDirectives(createElementVNode("div", {
    class: normalizeClass(["pon-expandable-image", $options.expandedImageClass]),
    ref: "expandedImage",
    style: normalizeStyle($options.transitionStyles)
  }, [$data.expanded ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "pon-expandable-image-close-button",
    ref: "closeButton",
    onClick: _cache[1] || (_cache[1] = $event => $options.closeImage())
  }, _hoisted_3$7, 512)) : createCommentVNode("", true), createElementVNode("img", mergeProps(_ctx.$attrs, {
    alt: $props.alt,
    style: {
      "width": "100%"
    }
  }), null, 16, _hoisted_4$5)], 6), [[vShow, $data.expanded || $data.expandedOverride]])]);
}

script$a.render = render$9;

var script$9 = {
  __name: 'Badge',
  props: {
    variant: {
      type: String,
      default: 'style1',
      validator(value) {
        return ['style1', 'style2', 'style3', 'style4'].includes(value);
      }
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["pon-badge", [__props.variant]]),
        "data-testid": "pon-badge"
      }, [createElementVNode("span", null, [renderSlot(_ctx.$slots, "default")])], 2);
    };
  }
};

var script$8 = {
  name: 'Gallery',
  components: {
    ExpandableImage: script$a
  },
  props: {
    lazyLoad: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: String,
      default: 'pon-gallery'
    },
    assetData: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(element => element.hasOwnProperty('image_url'));
      }
    },
    hasZoom: {
      type: Boolean,
      default: false
    },
    zoomDuration: {
      type: Number,
      default: 500
    }
  }
};

const _hoisted_1$8 = ["loading", "src", "data-src", "alt"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ExpandableImage = resolveComponent("ExpandableImage");
  return $props.hasZoom ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass($props.wrapperClass)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.assetData, (asset, index) => {
    return openBlock(), createBlock(_component_ExpandableImage, {
      animationDuration: $props.zoomDuration,
      key: index,
      loading: $props.lazyLoad && 'lazy',
      src: !$props.lazyLoad && asset.image_url,
      "data-src": asset.image_url,
      alt: asset.title || '',
      class: "pon-gallery__img",
      draggable: "false",
      "data-testid": "pon-gallery__img",
      style: {
        "object-fit": "contain"
      }
    }, null, 8, ["animationDuration", "loading", "src", "data-src", "alt"]);
  }), 128))], 2)) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass($props.wrapperClass)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.assetData, (asset, index) => {
    return openBlock(), createElementBlock("img", {
      key: index,
      loading: $props.lazyLoad && 'lazy',
      src: !$props.lazyLoad && asset.image_url,
      "data-src": asset.image_url,
      alt: asset.title || '',
      class: "pon-gallery__img",
      draggable: "false",
      "data-testid": "pon-gallery__img"
    }, null, 8, _hoisted_1$8);
  }), 128))], 2));
}

script$8.render = render$8;
script$8.__scopeId = "data-v-3f2ef3ae";

var script$7 = {
  name: 'ColorSelect',
  components: {
    Color: script$t
  },
  props: {
    colors: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(element => element.hasOwnProperty('identifier') && element.hasOwnProperty('primary'));
      }
    },
    disabledColorIdentifiers: {
      type: Array,
      default: []
    },
    selectedColorIdentifier: {
      type: String
    },
    selectedColorLabel: {
      type: String
    },
    colorSelectSize: {
      type: String
    },
    showTooltip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectColor(colorIdentifier) {
      this.$emit('update', colorIdentifier);
    },
    isDisabled(colorIdentifier) {
      return this.disabledColorIdentifiers.includes(colorIdentifier);
    }
  }
};

const _hoisted_1$7 = {
  class: "pon-color-select",
  "data-testid": "pon-color-select"
};
const _hoisted_2$6 = ["data-label-tooltip"];
const _hoisted_3$6 = {
  key: 0,
  class: "pon-color__label",
  "data-testid": "pon-color-label"
};
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Color = resolveComponent("Color");
  return openBlock(), createElementBlock("div", null, [createElementVNode("div", _hoisted_1$7, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.colors, color => {
    return openBlock(), createElementBlock("div", {
      key: color.identifier,
      class: normalizeClass(["pon-color-wrapper", [$props.showTooltip && 'has-tooltip']]),
      "data-label-tooltip": color.label,
      "data-testid": "pon-color-wrapper"
    }, [createVNode(_component_Color, {
      colorSelectSize: $props.colorSelectSize,
      primary: color.primary,
      secondary: color.secondary,
      selected: color.identifier === $props.selectedColorIdentifier,
      disabled: $options.isDisabled(color.identifier),
      onClick: $event => $options.selectColor(color.identifier)
    }, null, 8, ["colorSelectSize", "primary", "secondary", "selected", "disabled", "onClick"])], 10, _hoisted_2$6);
  }), 128))]), $props.selectedColorLabel ? (openBlock(), createElementBlock("span", _hoisted_3$6, toDisplayString($props.selectedColorLabel), 1)) : createCommentVNode("", true)]);
}

script$7.render = render$7;

var script$6 = {
  name: 'Modal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    transitionEnabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    transitionName() {
      return this.transitionEnabled ? 'pon-modal-fade' : null;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};

const _hoisted_1$6 = {
  class: "pon-modal__wrapper"
};
const _hoisted_2$5 = {
  class: "pon-modal",
  role: "dialog",
  "aria-labelledby": "modalTitle",
  "aria-describedby": "modalDescription"
};
const _hoisted_3$5 = {
  class: "pon-modal__header"
};
const _hoisted_4$4 = /*#__PURE__*/createElementVNode("span", {
  class: "close-icon"
}, null, -1);
const _hoisted_5$4 = {
  class: "pon-modal__body"
};
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: $options.transitionName
  }, {
    default: withCtx(() => [withDirectives(createElementVNode("div", _hoisted_1$6, [createElementVNode("div", {
      class: "pon-modal__backdrop",
      onClick: _cache[0] || (_cache[0] = function () {
        return $options.close && $options.close(...arguments);
      }),
      "data-testid": "modal-backdrop"
    }), createElementVNode("div", _hoisted_2$5, [createElementVNode("header", _hoisted_3$5, [renderSlot(_ctx.$slots, "header"), createElementVNode("button", {
      type: "button",
      class: "pon-modal__button--close",
      onClick: _cache[1] || (_cache[1] = function () {
        return $options.close && $options.close(...arguments);
      }),
      "aria-label": "Close modal",
      "data-testid": "modal-close-button"
    }, [renderSlot(_ctx.$slots, "close", {}, () => [_hoisted_4$4])])]), createElementVNode("section", _hoisted_5$4, [renderSlot(_ctx.$slots, "body")])])], 512), [[vShow, $props.open]])]),
    _: 3
  }, 8, ["name"]);
}

script$6.render = render$6;

var script$5 = {
  name: 'Prices',
  components: {
    Price: script$p
  },
  props: {
    locale: {
      type: String,
      default: 'nl-NL'
    },
    currency: {
      type: String,
      default: 'EUR'
    },
    price: {
      type: Number,
      required: true
    },
    base_price: {
      type: Number
    },
    monthly_price: {
      type: Number
    },
    price_prefix_label: {
      type: String,
      default: ''
    },
    monthly_price_label: {
      type: String,
      default: 'Per month:'
    }
  },
  computed: {
    hasDiscount() {
      return this.base_price && this.base_price !== this.price;
    },
    hasMonthlyPrice() {
      return this.monthly_price > 0;
    }
  }
};

const _hoisted_1$5 = {
  class: "pon-prices__regular"
};
const _hoisted_2$4 = {
  key: 0,
  class: "pon-prices__label",
  "data-testid": "price-regular-label"
};
const _hoisted_3$4 = {
  key: 1,
  class: "pon-prices__base",
  "data-testid": "price-base"
};
const _hoisted_4$3 = {
  class: "pon-prices__final",
  "data-testid": "price-final"
};
const _hoisted_5$3 = {
  key: 0,
  class: "monthly"
};
const _hoisted_6$3 = {
  key: 0,
  class: "pon-prices__label",
  "data-testid": "price-monthly-label"
};
const _hoisted_7$2 = {
  class: "pon-prices__final",
  "data-testid": "price-monthly"
};
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Price = resolveComponent("Price");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["pon-prices", {
      'has-discount': $options.hasDiscount,
      'has-monthly-price': $options.hasMonthlyPrice
    }])
  }, [createElementVNode("div", _hoisted_1$5, [$props.price_prefix_label ? (openBlock(), createElementBlock("span", _hoisted_2$4, toDisplayString($props.price_prefix_label), 1)) : createCommentVNode("", true), $options.hasDiscount ? (openBlock(), createElementBlock("span", _hoisted_3$4, [createVNode(_component_Price, {
    price: $props.base_price,
    locale: $props.locale,
    currency: $props.currency
  }, null, 8, ["price", "locale", "currency"])])) : createCommentVNode("", true), createElementVNode("span", _hoisted_4$3, [createVNode(_component_Price, {
    price: $props.price,
    locale: $props.locale,
    currency: $props.currency
  }, null, 8, ["price", "locale", "currency"])])]), $options.hasMonthlyPrice ? (openBlock(), createElementBlock("div", _hoisted_5$3, [$props.monthly_price_label ? (openBlock(), createElementBlock("span", _hoisted_6$3, toDisplayString($props.monthly_price_label), 1)) : createCommentVNode("", true), createElementVNode("span", _hoisted_7$2, [createVNode(_component_Price, {
    price: $props.monthly_price,
    locale: $props.locale,
    currency: $props.currency
  }, null, 8, ["price", "locale", "currency"])])])) : createCommentVNode("", true)], 2);
}

script$5.render = render$5;
script$5.__scopeId = "data-v-fba3307e";

var script$4 = {
  name: 'Tabs',
  props: {
    activeTab: {
      type: String
    }
  },
  setup(props, context) {
    const state = reactive({
      currentTab: '',
      tabs: []
    });
    const addTab = tab => {
      state.tabs.push(tab);
    };
    const selectTab = (identifier, index) => {
      state.currentTab = identifier;
      context.emit('tabs:select', index);
    };
    provide('tabsData', state);
    provide('addTab', addTab);
    return {
      ...toRefs(state),
      addTab,
      selectTab
    };
  },
  mounted() {
    if (this.tabs.length && this.tabs[0].title) {
      this.currentTab = this.tabs[0].title;
    }
    if (this.activeTab) {
      this.currentTab = this.activeTab;
    }
  }
};

const _hoisted_1$4 = {
  class: "pon-tabs",
  "data-testid": "tabs"
};
const _hoisted_2$3 = {
  key: 0,
  role: "tablist"
};
const _hoisted_3$3 = ["onClick"];
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [_ctx.tabs.length ? (openBlock(), createElementBlock("ul", _hoisted_2$3, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tabs, (tab, index) => {
    return openBlock(), createElementBlock("li", {
      class: normalizeClass({
        active: tab.isActive
      }),
      key: tab.title,
      onClick: $event => $setup.selectTab(tab.title, index),
      role: "tab",
      "data-testid": "tab"
    }, toDisplayString(tab.title), 11, _hoisted_3$3);
  }), 128))])) : createCommentVNode("", true), renderSlot(_ctx.$slots, "default")]);
}

script$4.render = render$4;
script$4.__scopeId = "data-v-52b3bb00";

var script$3 = {
  name: 'BikeFrameSelect',
  components: {
    BikeFrame: script$b
  },
  props: {
    frames: {
      type: Array,
      required: true
    },
    disabledFrames: {
      type: Array,
      default: []
    },
    selectedFrame: {
      type: String
    }
  },
  methods: {
    selectFrame(frame) {
      this.$emit('update', frame);
    },
    isDisabled(frame) {
      return this.disabledFrames.includes(frame);
    }
  }
};

const _hoisted_1$3 = {
  class: "pon-frame-select",
  "data-testid": "pon-frame-select"
};
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BikeFrame = resolveComponent("BikeFrame");
  return openBlock(), createElementBlock("div", _hoisted_1$3, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.frames, (frame, index) => {
    return openBlock(), createBlock(_component_BikeFrame, {
      key: index,
      selected: frame === $props.selectedFrame,
      onClick: $event => $options.selectFrame(frame),
      disabled: $options.isDisabled(frame),
      frame: frame
    }, null, 8, ["selected", "onClick", "disabled", "frame"]);
  }), 128))]);
}

script$3.render = render$3;

var script$2 = {
  name: 'AdvancedRating',
  components: {
    ProgressBar: script$n
  },
  data() {
    return {
      isActive: null
    };
  },
  props: {
    ratings: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(element => element.hasOwnProperty('star_number') && element.hasOwnProperty('percentage') && element.hasOwnProperty('number_of_reviews'));
      }
    },
    star_color: {
      type: String,
      default: 'gold',
      validator(value) {
        return isValidColor(value);
      }
    },
    bar_color: {
      type: String,
      default: 'blue',
      validator(value) {
        return isValidColor(value);
      }
    }
  },
  methods: {
    getSuffix(count) {
      return count === 1 ? `${count} review` : `${count} reviews`;
    }
  }
};

const _hoisted_1$2 = ["onClick"];
const _hoisted_2$2 = {
  class: "pon-advanced-rating__star-number"
};
const _hoisted_3$2 = /*#__PURE__*/createElementVNode("svg", {
  width: "0",
  height: "0",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/createElementVNode("symbol", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "rating-star"
}, [/*#__PURE__*/createElementVNode("path", {
  d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417\n            5.388 2.833-8.718-7.416-5.389h9.167z"
})])], -1);
const _hoisted_4$2 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "pon-star-rating__star",
  width: "20px",
  height: "20px"
};
const _hoisted_5$2 = ["fill"];
const _hoisted_6$2 = {
  class: "pon-advanced-rating__reviews"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProgressBar = resolveComponent("ProgressBar");
  return openBlock(true), createElementBlock(Fragment, null, renderList($props.ratings, (rating, index) => {
    return openBlock(), createElementBlock("div", {
      key: index,
      class: normalizeClass(["pon-advanced-rating", {
        'pon-advanced-rating--none': rating.number_of_reviews === 0,
        active: $data.isActive === index && rating.number_of_reviews !== 0
      }]),
      "data-testid": "pon-advanced-rating",
      onClick: $event => [_ctx.$emit('update:rating', rating), $data.isActive = index]
    }, [createElementVNode("span", _hoisted_2$2, toDisplayString(rating.star_number), 1), createElementVNode("div", null, [_hoisted_3$2, (openBlock(), createElementBlock("svg", _hoisted_4$2, [createElementVNode("use", {
      href: "#rating-star",
      fill: $props.star_color
    }, null, 8, _hoisted_5$2)]))]), createVNode(_component_ProgressBar, {
      percentage: rating.percentage,
      bar_color: $props.bar_color
    }, null, 8, ["percentage", "bar_color"]), createElementVNode("span", _hoisted_6$2, toDisplayString($options.getSuffix(rating.number_of_reviews)), 1)], 10, _hoisted_1$2);
  }), 128);
}

script$2.render = render$2;

var script$1 = {
  name: 'ProductTile',
  data() {
    return {
      color: '',
      frame: ''
    };
  },
  props: {
    lazyLoad: {
      type: Boolean,
      default: false
    },
    imageDataSet: {
      type: Object
    },
    identifier: {
      type: [String, Number],
      required: true
    },
    productName: {
      type: String,
      required: true
    },
    category: {
      type: String
    },
    label_text: {
      type: String
    },
    label_variant: {
      type: String,
      default: 'style1'
    },
    currency: {
      type: String
    },
    price: {
      type: Number,
      required: true
    },
    base_price: {
      type: Number
    },
    locale: {
      type: String
    },
    monthly_price: {
      type: Number
    },
    price_prefix_label: {
      type: String
    },
    monthly_price_label: {
      type: String
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array,
      validator(values) {
        return values.every(value => value.hasOwnProperty('identifier') && value.hasOwnProperty('primary'));
      }
    },
    frames: {
      type: Array
    },
    wrapperClass: {
      type: String,
      default: 'pon-product-tile'
    },
    callbackPrimaryButton: {
      type: Function
    },
    callbackSecondaryButton: {
      type: Function
    },
    buttonPrimaryText: {
      type: String
    },
    buttonPrimarySize: {
      type: String,
      default: 'default'
    },
    buttonSecondarySize: {
      type: String,
      default: 'default'
    },
    buttonPrimaryIcon: {
      type: Boolean,
      default: true
    },
    buttonSecondaryIcon: {
      type: Boolean,
      default: true
    },
    buttonSecondaryText: {
      type: String
    },
    buttonPrimaryUrl: {
      type: String
    },
    buttonSecondaryUrl: {
      type: String,
      default: '#'
    },
    assets: {
      type: Object,
      required: true
    }
  },
  components: {
    Prices: script$5,
    ColorSelect: script$7,
    BikeFrameSelect: script$3,
    Button: script$q,
    Badge: script$9
  },
  created() {
    if (this.colors) {
      this.color = this.colors[0].identifier;
    }
    if (this.frames) {
      /* eslint-disable-next-line */
      this.frame = this.frames[0];
    }
  },
  computed: {
    activeImage() {
      if (this.colors && this.frames) {
        return this.assets[[this.color, this.frame].join('-')];
      }
      if (this.colors) {
        return this.assets[this.color];
      }
      if (this.frames) {
        return this.assets[this.frame];
      }
      return this.assets[Object.keys(this.assets)[0]];
    },
    imageData() {
      if (!this.imageDataSet) {
        return null;
      }
      const dataSet = {};
      for (const [key, value] of Object.entries(this.imageDataSet)) {
        dataSet[`data-${key}`] = value;
      }
      return dataSet;
    },
    disabledColors() {
      return this.frames ? this.getDisabledColorsByFrame(this.frame) : [];
    }
  },
  methods: {
    updateColor(color) {
      this.color = color;
      this.emitChange();
      this.$emit('update:color', {
        id: this.identifier,
        value: color
      });
    },
    updateFrame(frame) {
      this.frame = frame;
      const disabledColors = this.getDisabledColorsByFrame(frame);
      if (disabledColors.includes(this.color)) {
        const enabledColors = this.getEnabledColorsByFrame(frame);
        this.updateColor(enabledColors[0]);
      }
      this.emitChange();
      this.$emit('update:frame', {
        id: this.identifier,
        value: frame
      });
    },
    emitChange() {
      this.$emit('update', {
        id: this.identifier,
        color: this.color,
        frame: this.frame
      });
    },
    buttonPrimaryAction(event) {
      if (this.callbackPrimaryButton) {
        this.callbackPrimaryButton(this.identifier, event);
      }
    },
    buttonSecondaryAction(event) {
      if (this.callbackSecondaryButton) {
        this.callbackSecondaryButton(this.identifier, event);
      }
    },
    getEnabledColorsByFrame(frame) {
      const colors = [];
      this.colors.forEach(color => {
        if (Object.keys(this.getAssetByFrameAndColor(frame, color.identifier)).length !== 0) {
          colors.push(color.identifier);
        }
      });
      return colors;
    },
    getDisabledColorsByFrame(frame) {
      const colors = [];
      this.colors.forEach(color => {
        if (Object.keys(this.getAssetByFrameAndColor(frame, color.identifier)).length === 0) {
          colors.push(color.identifier);
        }
      });
      return colors;
    },
    getAssetByFrameAndColor(frame, color) {
      return this.assets[[color, frame].join('-')] || {};
    }
  }
};

const _hoisted_1$1 = {
  class: "productInfo"
};
const _hoisted_2$1 = {
  class: "productHeader"
};
const _hoisted_3$1 = {
  key: 0
};
const _hoisted_4$1 = ["innerHTML"];
const _hoisted_5$1 = {
  class: "productFooter"
};
const _hoisted_6$1 = {
  class: "productButtons"
};
const _hoisted_7$1 = ["loading", "src", "data-src", "alt"];
const _hoisted_8$1 = {
  class: "productHeader"
};
const _hoisted_9$1 = {
  key: 0
};
const _hoisted_10$1 = ["innerHTML"];
const _hoisted_11$1 = ["loading", "src", "data-src", "alt"];
const _hoisted_12 = {
  class: "productFooter"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Prices = resolveComponent("Prices");
  const _component_ColorSelect = resolveComponent("ColorSelect");
  const _component_BikeFrameSelect = resolveComponent("BikeFrameSelect");
  const _component_Button = resolveComponent("Button");
  const _component_Badge = resolveComponent("Badge");
  return $props.isHorizontal ? (openBlock(), createElementBlock("div", {
    key: 0,
    "data-testid": "isHorizontal",
    class: normalizeClass(["horizontal", $props.wrapperClass])
  }, [createElementVNode("div", _hoisted_1$1, [createElementVNode("div", _hoisted_2$1, [$props.category ? (openBlock(), createElementBlock("h5", _hoisted_3$1, toDisplayString($props.category), 1)) : createCommentVNode("", true), createElementVNode("h3", {
    innerHTML: $props.productName
  }, null, 8, _hoisted_4$1), renderSlot(_ctx.$slots, "prices", {}, () => [createVNode(_component_Prices, {
    price: $props.price,
    base_price: $props.base_price,
    monthly_price: $props.monthly_price,
    locale: $props.locale,
    currency: $props.currency,
    price_prefix_label: $props.price_prefix_label,
    monthly_price_label: $props.monthly_price_label
  }, null, 8, ["price", "base_price", "monthly_price", "locale", "currency", "price_prefix_label", "monthly_price_label"])])]), createElementVNode("div", _hoisted_5$1, [renderSlot(_ctx.$slots, "swatches", {}, () => [$props.colors ? (openBlock(), createBlock(_component_ColorSelect, {
    key: 0,
    "data-testid": "pon-color-swatch",
    colors: $props.colors,
    onUpdate: $options.updateColor,
    selectedColorIdentifier: $data.color
  }, null, 8, ["colors", "onUpdate", "selectedColorIdentifier"])) : createCommentVNode("", true), $props.frames ? (openBlock(), createBlock(_component_BikeFrameSelect, {
    key: 1,
    "data-testid": "pon-frame-swatch",
    frames: $props.frames,
    onUpdate: $options.updateFrame,
    disabledFrames: [],
    selectedFrame: $data.frame
  }, null, 8, ["frames", "onUpdate", "selectedFrame"])) : createCommentVNode("", true)]), createElementVNode("div", _hoisted_6$1, [renderSlot(_ctx.$slots, "secondary-button", {}, () => [$props.buttonSecondaryText ? (openBlock(), createBlock(_component_Button, {
    key: 0,
    type: "secondary",
    text: $props.buttonSecondaryText,
    url: $props.buttonSecondaryUrl,
    icon: $props.buttonSecondaryIcon,
    size: $props.buttonSecondarySize,
    onClick: $options.buttonSecondaryAction
  }, null, 8, ["text", "url", "icon", "size", "onClick"])) : createCommentVNode("", true)]), renderSlot(_ctx.$slots, "primary-button", {}, () => [$props.buttonPrimaryText ? (openBlock(), createBlock(_component_Button, {
    key: 0,
    text: $props.buttonPrimaryText,
    url: $props.buttonPrimaryUrl,
    icon: $props.buttonPrimaryIcon,
    size: $props.buttonPrimarySize,
    onClick: $options.buttonPrimaryAction
  }, null, 8, ["text", "url", "icon", "size", "onClick"])) : createCommentVNode("", true)])])])]), (openBlock(), createBlock(resolveDynamicComponent($props.callbackPrimaryButton ? 'div' : 'a'), {
    href: $props.buttonPrimaryUrl,
    onClick: $options.buttonPrimaryAction,
    class: "productImage"
  }, {
    default: withCtx(() => [$props.label_text ? (openBlock(), createBlock(_component_Badge, {
      key: 0,
      variant: $props.label_variant
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString($props.label_text), 1)]),
      _: 1
    }, 8, ["variant"])) : createCommentVNode("", true), createElementVNode("img", mergeProps({
      loading: $props.lazyLoad && 'lazy',
      src: !$props.lazyLoad && $options.activeImage,
      "data-src": $options.activeImage
    }, $options.imageData, {
      alt: $props.productName,
      "data-testid": "pon-product-tile__image"
    }), null, 16, _hoisted_7$1)]),
    _: 1
  }, 8, ["href", "onClick"]))], 2)) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass($props.wrapperClass)
  }, [createElementVNode("div", _hoisted_8$1, [$props.category ? (openBlock(), createElementBlock("h5", _hoisted_9$1, toDisplayString($props.category), 1)) : createCommentVNode("", true), createElementVNode("h3", {
    innerHTML: $props.productName
  }, null, 8, _hoisted_10$1), renderSlot(_ctx.$slots, "prices", {}, () => [createVNode(_component_Prices, {
    price: $props.price,
    base_price: $props.base_price,
    monthly_price: $props.monthly_price,
    locale: $props.locale,
    currency: $props.currency,
    price_prefix_label: $props.price_prefix_label,
    monthly_price_label: $props.monthly_price_label
  }, null, 8, ["price", "base_price", "monthly_price", "locale", "currency", "price_prefix_label", "monthly_price_label"])])]), (openBlock(), createBlock(resolveDynamicComponent($props.callbackPrimaryButton ? 'div' : 'a'), {
    href: $props.buttonPrimaryUrl,
    onClick: $options.buttonPrimaryAction,
    class: "productImage"
  }, {
    default: withCtx(() => [$props.label_text ? (openBlock(), createBlock(_component_Badge, {
      key: 0,
      variant: $props.label_variant
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString($props.label_text), 1)]),
      _: 1
    }, 8, ["variant"])) : createCommentVNode("", true), createElementVNode("img", mergeProps({
      loading: $props.lazyLoad && 'lazy',
      src: !$props.lazyLoad && $options.activeImage,
      "data-src": $options.activeImage
    }, $options.imageData, {
      alt: $props.productName,
      "data-testid": "pon-product-tile__image"
    }), null, 16, _hoisted_11$1)]),
    _: 1
  }, 8, ["href", "onClick"])), createElementVNode("div", _hoisted_12, [renderSlot(_ctx.$slots, "swatches", {}, () => [$props.frames ? (openBlock(), createBlock(_component_BikeFrameSelect, {
    key: 0,
    "data-testid": "pon-frame-swatch",
    frames: $props.frames,
    onUpdate: $options.updateFrame,
    disabledFrames: [],
    selectedFrame: $data.frame
  }, null, 8, ["frames", "onUpdate", "selectedFrame"])) : createCommentVNode("", true), $props.colors ? (openBlock(), createBlock(_component_ColorSelect, {
    key: 1,
    colors: $props.colors,
    onUpdate: $options.updateColor,
    disabledColorIdentifiers: $options.disabledColors,
    selectedColorIdentifier: $data.color
  }, null, 8, ["colors", "onUpdate", "disabledColorIdentifiers", "selectedColorIdentifier"])) : createCommentVNode("", true)]), renderSlot(_ctx.$slots, "secondary-button", {}, () => [$props.buttonSecondaryText ? (openBlock(), createBlock(_component_Button, {
    key: 0,
    type: "secondary",
    text: $props.buttonSecondaryText,
    url: $props.buttonSecondaryUrl,
    icon: $props.buttonSecondaryIcon,
    size: $props.buttonSecondarySize,
    onClick: $options.buttonSecondaryAction
  }, null, 8, ["text", "url", "icon", "size", "onClick"])) : createCommentVNode("", true)]), renderSlot(_ctx.$slots, "primary-button", {}, () => [$props.buttonPrimaryText ? (openBlock(), createBlock(_component_Button, {
    key: 0,
    text: $props.buttonPrimaryText,
    url: $props.buttonPrimaryUrl,
    icon: $props.buttonPrimaryIcon,
    size: $props.buttonPrimarySize,
    onClick: $options.buttonPrimaryAction
  }, null, 8, ["text", "url", "icon", "size", "onClick"])) : createCommentVNode("", true)])])], 2));
}

script$1.render = render$1;

var script = {
  name: 'ThreeSixty',
  props: {
    lazyLoadFallback: {
      type: Boolean,
      default: false
    },
    assets: {
      type: Array,
      required: true
    },
    altText: {
      type: String
    },
    mainImageIndex: {
      type: Number,
      default: 29
    },
    rotationsSpeed: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      carousel: {
        currentImage: this.mainImageIndex
      },
      mouse: {
        isMoving: false,
        savedPositionX: 0,
        currentPositionX: 0
      }
    };
  },
  computed: {
    maxImages() {
      return this.assets.length - 1;
    },
    activeImage() {
      if (this.maxImages > this.mainImageIndex) {
        return this.assets[this.carousel.currentImage];
      }
      return this.assets[0];
    },
    fallbackImage() {
      return this.lazyLoadFallback ? this.activeImage : null;
    }
  },
  methods: {
    handleMouseUp() {
      this.mouse.isMoving = false;
    },
    handleMouseLeave() {
      if (this.mouse.isMoving) {
        this.mouse.isMoving = false;
      }
    },
    handleMouseDown(event) {
      this.mouse.savedPositionX = event.pageX;
      this.mouse.isMoving = true;
    },
    handleTouchStart(event) {
      event.preventDefault();
      this.mouse.savedPositionX = event.touches[0].pageX;
      this.mouse.isMoving = true;
    },
    handleTouchEnd() {
      this.mouse.isMoving = false;
    },
    handleTouchMove(event) {
      event.preventDefault();
      this.handleMovement(event.touches[0].pageX);
    },
    handleMouseMove(event) {
      this.handleMovement(event.pageX);
    },
    handleMovement(currentPosition) {
      if (this.mouse.isMoving) {
        this.mouse.currentPositionX = currentPosition;
        const distance = this.mouse.currentPositionX - this.mouse.savedPositionX;
        if (Math.abs(distance) > this.rotationsSpeed) {
          this.mouse.savedPositionX = this.mouse.currentPositionX;
          if (distance > 0) {
            this.nextImage();
          } else {
            this.previousImage();
          }
        }
      }
    },
    previousImage() {
      if (this.carousel.currentImage === 0) {
        this.carousel.currentImage = this.maxImages;
      }
      this.carousel.currentImage -= 1;
    },
    nextImage() {
      if (this.carousel.currentImage === this.maxImages) {
        this.carousel.currentImage = 0;
      }
      this.carousel.currentImage += 1;
    }
  }
};

const _hoisted_1 = {
  class: "pon-three-sixty"
};
const _hoisted_2 = {
  class: "pon-three-sixty__rotatable",
  "data-testid": "three-sixty-rotatable"
};
const _hoisted_3 = ["alt", "src"];
const _hoisted_4 = {
  class: "pon-three-sixty__rotation-arrows"
};
const _hoisted_5 = /*#__PURE__*/createElementVNode("svg", {
  class: "pon-three-sixty__arrow pon-three-sixty__arrow--prev",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}, [/*#__PURE__*/createElementVNode("path", {
  d: "m345.44 248.29l-194.29 194.28c-12.359 12.365-32.397\n                12.365-44.75 0-12.354-12.354-12.354-32.391\n                0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394\n                0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177\n                6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373",
  transform: "matrix(.03541-.00013.00013.03541 2.98 3.02)"
})], -1);
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = /*#__PURE__*/createElementVNode("svg", {
  class: "pon-three-sixty__arrow pon-three-sixty__arrow--next",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}, [/*#__PURE__*/createElementVNode("path", {
  d: "m345.44 248.29l-194.29 194.28c-12.359\n                12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391\n                0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394\n                0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177\n                6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373",
  transform: "matrix(.03541-.00013.00013.03541 2.98 3.02)"
})], -1);
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = /*#__PURE__*/createElementVNode("div", {
  class: "pon-three-sixty__oval"
}, null, -1);
const _hoisted_10 = {
  key: 1,
  class: "pon-three-sixty__single",
  "data-testid": "three-sixty-single"
};
const _hoisted_11 = ["loading", "src", "data-src", "alt"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [this.maxImages > this.mainImageIndex ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createElementVNode("div", _hoisted_2, [createElementVNode("img", {
    id: "pon-three-sixty-image",
    class: "pon-three-sixty__image",
    alt: $props.altText,
    src: $options.activeImage,
    draggable: "false",
    onMouseup: _cache[0] || (_cache[0] = function () {
      return $options.handleMouseUp && $options.handleMouseUp(...arguments);
    }),
    onMousedown: _cache[1] || (_cache[1] = function () {
      return $options.handleMouseDown && $options.handleMouseDown(...arguments);
    }),
    onMousemove: _cache[2] || (_cache[2] = function () {
      return $options.handleMouseMove && $options.handleMouseMove(...arguments);
    }),
    onMouseleave: _cache[3] || (_cache[3] = function () {
      return $options.handleMouseLeave && $options.handleMouseLeave(...arguments);
    }),
    onTouchend: _cache[4] || (_cache[4] = function () {
      return $options.handleTouchEnd && $options.handleTouchEnd(...arguments);
    }),
    onTouchstart: _cache[5] || (_cache[5] = function () {
      return $options.handleTouchStart && $options.handleTouchStart(...arguments);
    }),
    onTouchmove: _cache[6] || (_cache[6] = function () {
      return $options.handleTouchMove && $options.handleTouchMove(...arguments);
    })
  }, null, 40, _hoisted_3)]), createElementVNode("div", _hoisted_4, [createElementVNode("button", {
    onClick: _cache[7] || (_cache[7] = function () {
      return $options.previousImage && $options.previousImage(...arguments);
    }),
    class: "previous threesixty-previous-button"
  }, _hoisted_6), createElementVNode("button", {
    onClick: _cache[8] || (_cache[8] = function () {
      return $options.nextImage && $options.nextImage(...arguments);
    }),
    class: "next threesixty-next-button"
  }, _hoisted_8)]), _hoisted_9], 64)) : (openBlock(), createElementBlock("div", _hoisted_10, [createElementVNode("img", {
    loading: $props.lazyLoadFallback && 'lazy',
    src: $options.fallbackImage,
    "data-src": $options.activeImage,
    alt: $props.altText
  }, null, 8, _hoisted_11)]))]);
}

script.render = render;

/* Atoms */

/* Templates */

/* Pages */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Color: script$t,
  Loader: script$s,
  MainTitle: script$r,
  Button: script$q,
  Price: script$p,
  StarRating: script$o,
  ProgressBar: script$n,
  Swatches: script$m,
  Accordion: script$l,
  Slogan: script$k,
  USP: script$j,
  Breadcrumb: script$i,
  Breadcrumbs: script$h,
  Tab: script$g,
  Tooltip: script$f,
  BikeFrame: script$b,
  ExpandableImage: script$a,
  Badge: script$9,
  Gallery: script$8,
  ColorSelect: script$7,
  Modal: script$6,
  Prices: script$5,
  Tabs: script$4,
  BikeFrameSelect: script$3,
  AdvancedRating: script$2,
  ProductTile: script$1,
  ThreeSixty: script
});

// Import vue components

// install function executed by Vue.use()
const install = function installPonBikeVueComponents(app) {
  Object.entries(components).forEach(_ref => {
    let [componentName, component] = _ref;
    app.component(componentName, component);
  });
};

export { script$l as Accordion, script$2 as AdvancedRating, script$9 as Badge, script$b as BikeFrame, script$3 as BikeFrameSelect, script$i as Breadcrumb, script$h as Breadcrumbs, script$q as Button, script$t as Color, script$7 as ColorSelect, script$a as ExpandableImage, script$8 as Gallery, script$s as Loader, script$r as MainTitle, script$6 as Modal, script$p as Price, script$5 as Prices, script$1 as ProductTile, script$n as ProgressBar, script$k as Slogan, script$o as StarRating, script$m as Swatches, script$g as Tab, script$4 as Tabs, script as ThreeSixty, script$f as Tooltip, script$j as USP, install as default };
